module.exports = "/images/vendor/@sellers-shield-home-protection/ss-ui-kit/src/static/caret-round.svg?c9f64ccbf5674ca06cf6a1c8634da502";